module.exports = __webpack_public_path__ + "img/notice-sub3.72dba012.png";